export default "__VITE_ASSET__05579ecb__"